import { ABILITIES, AUTH_NAMESPACE, USER } from "store/modules/auth";
import moment from "moment";
const mixin = {
  computed: {
    /**
    * Retorna o usuário logado salvo no $store
    */
    $user() {
      return {
        ...this.$store.getters[`${AUTH_NAMESPACE}/${USER}`],
        permissions: this.$store.getters[`${AUTH_NAMESPACE}/${ABILITIES}`]
      }
    },
    /**
    * Retorna a propriedade padrão usada em todas as tabelas
    */
    $footerProps() {
      return {
        'items-per-page-options': [10, 20, 50, -1],
      };
    },
    /**
    * Retorna a data/hora de hoje formatada
    */
    $hoje() {
      return new Date().toLocaleDateString()
    },
    $buildDev() {
      return this.$configurations.env.nodeEnv == "development"
    },
    $recaptchaDev() {
      return this.$configurations.env.recaptcha == "development";
    },
    $opcoesUFS() {
      return [
        { value: 'AC' },
        { value: 'AL' },
        { value: 'AP' },
        { value: 'AM' },
        { value: 'BA' },
        { value: 'CE' },
        { value: 'DF' },
        { value: 'ES' },
        { value: 'GO' },
        { value: 'MA' },
        { value: 'MT' },
        { value: 'MS' },
        { value: 'MG' },
        { value: 'PA' },
        { value: 'PB' },
        { value: 'PR' },
        { value: 'PE' },
        { value: 'PI' },
        { value: 'RJ' },
        { value: 'RN' },
        { value: 'RS' },
        { value: 'RO' },
        { value: 'RR' },
        { value: 'SC' },
        { value: 'SP' },
        { value: 'SE' },
        { value: 'TO' }
      ]
    },
    $opcoesGrauEscolaridade() {
      return [
        { value: 'ensino fundamental completo', descricao: "Ensino fundamental completo" },
        { value: 'ensino fundamental incompleto', descricao: "Ensino fundamental incompleto" },
        { value: 'ensino medio completo', descricao: "Ensino médio completo" },
        { value: 'ensino medio incompleto', descricao: "Ensino médio incompleto" },
        { value: 'ensino superior completo', descricao: "Ensino superior completo" },
        { value: 'ensino superior incompleto', descricao: "Ensino superior incompleto" },
        { value: 'pos graduacao', descricao: "Pós-graduação" },
      ]
    },
    $opcoesMeses() {
      return [
        { value: 1, descricao: "Janeiro" },
        { value: 2, descricao: "Fevereiro" },
        { value: 3, descricao: "Março" },
        { value: 4, descricao: "Abril" },
        { value: 5, descricao: "Maio" },
        { value: 6, descricao: "Junho" },
        { value: 7, descricao: "Julho" },
        { value: 8, descricao: "Agosto" },
        { value: 9, descricao: "Setembro" },
        { value: 10, descricao: "Outubro" },
        { value: 11, descricao: "Novembro" },
        { value: 12, descricao: "Dezembro" },
      ]
    },
    $situacaoParecer() {
      return [
        { value: 'aprovado', descricao: "Aprovado" },
        { value: 'recusado', descricao: "Recusado" },
      ]
    },
    $diaLetivo() {
      return [
        { value: true, descricao: "Sim" },
        { value: false, descricao: "Não" },
      ]
    },
  },
  methods: {
    /**
    * Redireciona para a página home
    * @param app Opcional - path home a ser redirecionado
    */
    $toHome(app = "/app") {
      this.$router.push({ path: app });
    },
    /**
    * Retorna uma página no histórico
    */
    $back() {
      this.$router.go(-1);
    },
    /**
    * Reseta o form padrão ref="form" e o captcha caso exista
    * @param form Opcional - Referência da tag form em tela
    */
    $resetForm(form) {
      form ? form.reset() : this.$refs.form.reset();
      this.$refs.recaptcha && this.$refs.recaptcha.onCaptchaExpired();
    },
    /**
    * Valida o formulário mostrando a mensagem caso inválido
    * @param msg Opcional - Mensagem de campos obrigatórios
    * @param form Opcional - Referencia do form que vem da tag <v-form> (this.$refs)
    */
    $validarFormulario(msg = "Todos os campos obrigatórios devem ser preenchidos.", form = "form") {
      return this.$refs[form].validate()
        ? true
        : this.$notifyWarning(msg)
    },
    /**
    * Converte um base64 em um new File()
    * @param base64 String de base64
    * @param filename Nome do arquivo gerado
    * @param mimeType Formato do arquivo
    */
    $convertBase64ToFile(base64, filename, mimeType) {
      return (fetch(`data:${mimeType};base64,${base64}`)
        .then((res) => res.arrayBuffer())
        .then((buf) => new File([buf], filename, { type: mimeType }))
      );
    },
    /**
    * Formata o CPF no formato padrão '###.###.###-##'
    * @param value Valor do CPF a ser formatado
    */
    $formatCpf(cpf) {
      return (cpf || '').replace(/[^\d]/g, '').replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    },
    /**
    * Verifica se o usuário logado possui alguma permissão de "administrador."
    */
    $isUserAdmin() {
      return this.$user && this.$user.roles?.some((r) => ['ADMINISTRADOR', 'GGEIAI', 'ARTICULADOR REGIONAL'].includes(r.toUpperCase()));
    },
    /**
    * Retira a máscara do CPF e Telefone
    * @param value Valor do CPF mascarado
    * @example $unMask('123.456.789-00') // 12345678900
    * @example $unMask('(99) 9999-9999') // 9999999999
    */
    $unMask(value) {
      if (!value) return "";
      return value
        .split(".").join("")
        .split("-").join("")
        .split("(").join("")
        .split(")").join("")
        .split(" ").join("");
    },
    /**
    * Ignora caso o usuário não tenha digitado um número no input
    * usar em conjunto do @keypress="$event"
    * @param evt Evento recebido pelo input
    */
    $isNumber(evt) {
      if (!["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"].includes(evt.key)) {
        evt.preventDefault();
      }
    },
    /**
    * Rola a página até o topo
    */
    $scrollToTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    },
    /**
    * Formata o date em formato americano para enviar para a api
    * @param data String da data a ser enviada para o back
    * @param hora Opcional - String da Hora em formato 'hh:mm:ss'
    */
    $formatarDateParaEnviar(data, hora = "00:00:00") {
      if (data) {
        // Caso a data já esteja no formato correto, ignora
        if (data.includes("T")) {
          return data;
        }
        // Caso a data esteja no formato DD/MM/YYYY
        if (data.includes("/")) {
          const [dia, mes, ano] = data.split("/");
          return `${ano}-${mes}-${dia}T${hora}`;
        } else {
          return `${data}T${hora}`;
        }
      }
      return null;
    },
    /**
    * Esconde o CPF em tela adicionando # no formato '###.###.000-##'
    * @param value Valor do CPF a ser mascarado
    */
    $esconderCpf(value) {
      return this.$formatCpf(value)
        .split("")
        .map((v, i) => {
          return [8, 9, 10].includes(i) || v.includes(".") || v.includes("-")
            ? v
            : "#";
        })
        .toString()
        .split(",")
        .join("");
    },
    /**
    * Monta os params corretamente enviando null no lugar de 'Todos'.
    * Converte o objeto params montado em um objeto do tipo URLSearchParams.
    * Essa conversão é necessária em alguns cenários para realizar corretamente o envio de arrays para a API.
    * @param filters Objeto contendo os filtros informados em tela Ex: this.form.filters
    */
    $montarParamsFilters(filters) {
      const params = {
        ...filters,
        situacao: filters.situacao == "Todas" ? null : filters.situacao,
        ano: filters.ano == "Todos" ? null : filters.ano,
        semestre: filters.semestre == "Todos" ? null : filters.semestre
      }
      const urlSearchParams = new URLSearchParams();
      Object.keys(params).forEach(key => {
        if (Array.isArray(params[key])) {
          params[key].forEach(item => {
            if (item) {
              urlSearchParams.append(key, item);
            }
          });
        } else if (params[key]) {
          urlSearchParams.append(key, params[key]);
        }
      });
      return { params: urlSearchParams };
    },
    /**
    * Cria um elemento CSV na tela e realiza o download no navegador do usuário.
    * @param bytes Array de bytes retornado pelo back-end
    * @param nomeDoRelatorio Nome do relatório (sem a extensão .csv) a ser baixado
    */
    $baixarRelatorioCSV(bytes, nomeDoRelatorio = "relatorio", msg = "Relatório baixado com sucesso!") {
      const getEncodeData = () => encodeURIComponent(`\uFEFF${bytes}`);
      const a = window.document.createElement("a");
      a.setAttribute("href", `data:text/csv; charset=utf-8,${getEncodeData()}`);
      a.setAttribute("download", `${nomeDoRelatorio}.csv`);
      a.click();
      this.$notifySuccess(msg);
    },
    /**
    * Cria um elemento PDF na tela e realiza o download no navegador do usuário.
    * @param bytes Array de bytes retornado pelo back-end
    * @param nomeDoRelatorio Nome do relatório (sem a extensão .pdf) a ser baixado
    */
    $baixarRelatorioPDF(data, nomeDoRelatorio, msg = "Relatório baixado com sucesso!") {
      const url = URL.createObjectURL(data);
      const link = document.createElement('a');
      link.href = url;
      const nomeDoRelatorioFormatado = nomeDoRelatorio ? `${nomeDoRelatorio}.pdf` : `relatorio-${Date.now()}.pdf`;
      link.setAttribute('download', nomeDoRelatorioFormatado);
      document.body.appendChild(link);
      link.click();
      link.remove();
      this.$notifySuccess(msg);
    },
    $base64ToArrayBuffer(data) {
      const bString = window.atob(data);
      const bLength = bString.length;
      const bytes = new Uint8Array(bLength);
      for (var i = 0; i < bLength; i++) {
        var ascii = bString.charCodeAt(i);
        bytes[i] = ascii;
      }
      return bytes;
    },
    $getFileFromBase64(base64, fileName, fileType, extension) {
      const bufferArray = this.$base64ToArrayBuffer(base64);
      const blob = new Blob([bufferArray], { type: fileType });
      return new File([blob], `${fileName}.${extension}`)
    },
    $validateCep(cep) {
      return /^[\d]{8}$/.test(cep) || 'CEP inválido';
    },
    $validarTamanhoCEP(cep) {
      const cepSemMascara = cep?.replace(/\D/g, "");
      return cepSemMascara?.length === 8;
    },
    $formatarCpf(cpf) {
      return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    },
    $formatarCep(cep) {
      return cep.replace(/(\d{2})(\d{3})(\d{3})/, "$1.$2-$3");
    },
    $getParamsObject(params) {
      return { ...params, responseType: "blob" }
    },
    $formatarDataHora(value, format = 'DD/MM/YYYY HH:mm:ss') {
      if (!value) {
        return '';
      }

      try {
        return moment(value).format(format);
      } catch {
        console.warn('Data/Hora inválida: ', value);
        return '';
      }
    },
    $possuiPermissao(permissao) {
      return this.$user.permissions?.some((p) => p.toLowerCase() === permissao.toLowerCase());
    },
    $textoDaSolicitacaoDeAcesso() {
      const userRoles = this.$user?.roles.map((role) => role.toUpperCase()) || [];
      const roleMap = {
        'ADMINISTRADOR': 'Solicitações de Acesso - Administrador',
        'GGEIAI': 'Solicitações de Acesso - GGEIAI',
        'ARTICULADOR REGIONAL': 'Solicitações de Acesso - Articulador Regional',
      };

      for (const role of userRoles) {
        if (roleMap[role]) {
          return roleMap[role];
        }
      }

      return 'Solicitações de Acesso - Administrador';
    },
    $capitalize(value) {
      if (!value) return '';
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    $horaValida(h) {
      if (!h) return true;
      const [hora, minuto] = h.split(':').filter(x => x.length === 2).map(x => parseInt(x));
      const condicao = hora >= 0 && hora <= 23 && minuto >= 0 && minuto <= 59;
      return condicao || 'Hora inválida';
    },
    $temPeloMenosUmNaoNulo(obj) {
      return Object.values(obj).some(
        valor => valor !== null && valor !== undefined && (typeof valor === 'boolean' || valor)
      );
    },
    $customSort(items, sortBy, sortDesc) {
      if (!Array.isArray(items)) return items;

      return [...items].sort((a, b) => {
        for (let i = 0; i < sortBy.length; i++) {
          const key = sortBy[i];
          const desc = sortDesc[i];

          let aValue = a[key];
          let bValue = b[key];

          const aIsEmpty = aValue === null || aValue === undefined || aValue === '';
          const bIsEmpty = bValue === null || bValue === undefined || bValue === '';

          // Se um é vazio e o outro não → o vazio vai para o final
          if (aIsEmpty && !bIsEmpty) return 1;
          if (!aIsEmpty && bIsEmpty) return -1;
          if (aIsEmpty && bIsEmpty) continue; // ambos vazios, passa para o próximo sortBy se houver

          // Normaliza se forem strings
          if (typeof aValue === 'string') {
            aValue = aValue.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim();
          }
          if (typeof bValue === 'string') {
            bValue = bValue.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim();
          }

          if (aValue < bValue) return desc ? 1 : -1;
          if (aValue > bValue) return desc ? -1 : 1;
        }
        return 0;
      });
    },
    $anosCalendarioAntesDepois() {
      const currentYear = new Date().getFullYear();
      const range = 2;

      return Array.from({ length: range * 2 + 1 }, (_, i) => {
        const ano = currentYear - range + i;
        return { id: ano, ano };
      });
    },
  },
};
export default mixin;
